<template>
  <div class="d-flex flex-column align-items-center">
    <div class="app-container col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3 vue-container">
      <LoadingOverlay class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3" v-if="this.isLoading" />
      <router-view />
    </div>
  </div>
</template>

<script>
import LoadingOverlay from "@/views/components/LoadingOverlay";
import { setBrandConfig } from "@/functions/setBrandConfig";
import { mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapState(['isLoading'])
  },
  components: {
    LoadingOverlay
  },
  methods: {
    ...mapMutations(['setDeferredPrompt', 'setFeedArticles']),
    captureEvent() {
      window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault()
        // Stash the event so it can be triggered later.
        this.setDeferredPrompt(e)
      })
    },
    async setNewsFeed() {
      // TODO: Fetch news articles from service
      // this.setFeedArticles(await NewsService.getNews());
    },
  },
  beforeMount() {
    this.setNewsFeed();
    this.captureEvent();
    setBrandConfig();
  }
}
</script>

<style lang="scss">
@import "../public/globalStyles/global";

.vue-container {
  position: relative;
  font-family: 'ClashDisplay-Regular', sans-serif;
  background: linear-gradient(180deg, #080a0e 0%, #1f1f1f 100%);
  background-size: cover;
  min-height: 100vh;
  overflow-x: hidden;
}

html, body {
  background-color: #1f1f1f;
  margin: 0;
  padding: 0;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #1f1f1f;
}
</style>
